import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Tienda } from '../models/tienda';
import { DataCombo } from '../models/combo';

@Injectable({
  providedIn: 'root'
})

export class TiendaService {

  private url: string;

  constructor(private http: HttpClient) {
    this.url = environment.url + "tienda/";
  }

  getTiendas(activo?: boolean): Observable<Tienda[]> {
    if (activo) {
      this.url += "?active=" + activo;
    }
    return this.http.get<Tienda[]>(this.url);
  }

  getTiendasUser(activo?: boolean): Observable<Tienda[]> {
    let urlcom = this.url + "user";

    if (activo) {
      urlcom += "?active=" + activo;
    }
    return this.http.get<Tienda[]>(urlcom);
  }

  getTiendaById(id: number): Observable<Tienda> {
    let urlcom = this.url + id;
    return this.http.get<Tienda>(urlcom);
  }

  updateTienda(id: number, tienda: Tienda): Observable<Tienda> {
    let urlcom = this.url + id;
    return this.http.put<Tienda>(urlcom, tienda);
  }

  saveTienda(tienda: Tienda): Observable<Tienda> {
    let urlcom = this.url + "register/";
    return this.http.post<Tienda>(urlcom, tienda);
  }

  deleteTienda(id: number): Observable<any> {
    let urlcom = this.url + id;
    return this.http.delete(urlcom);
  }

  activarTienda(id: number): Observable<Tienda> {
    let urlcom = this.url + "activate/" + id;
    return this.http.put<Tienda>(urlcom, null);
  }

  getTiendasCombo(): Observable<DataCombo[]> {
    let urlcom = this.url + "combo";
    return this.http.get<DataCombo[]>(urlcom);
  }

}
